export default __webpack_public_path__ + "54464c6861aec5de4d5c638ea29f7e6d.png";